import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-display-list",
  "use": "svgIcon-display-list-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-display-list\"><g fill=\"currentColor\"><path d=\"m0 2.6h36v6h-36v-6\" /><path d=\"m0 27.4h36v6h-36v-6\" /><path d=\"m0 15h36v6h-36v-6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol